// Fixed Asset Types Getters

export const getFixedAssetTypesList = state => {
  return state.fixedAssetTypesList
}

export const getFixedAssetTypeInfo = state => {
  return state.fixedAssetTypeInfo
}

export const getFullFixedAssetTypesList = state => {
  return state.fullFixedAssetTypesList
}
